AUI().ready(
    'liferay-sign-in-modal',
    function (A) {
        var signIn = A.one('.sign-in > a');

        if (signIn && signIn.getData('redirect') !== 'true') {
            signIn.plug(Liferay.SignInModal);
        }
    }
);

$(document).ready(function () {

    /* Menu toggle icon function */
    function toggleIcon(icon) {
        icon.each(function () {
            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden').addClass('is-visible');
            } else if ($(this).hasClass('is-visible')) {
                $(this).removeClass('is-visible').addClass('is-hidden');
            }
        });
    }

    /* Remove padding from empty wrappers */
    $('.portlet-column').find('.portlet-dropzone').each(function () {
        if($(this).hasClass('empty')) {
            $(this).closest('.portlet-column .rt-wrapper').css('padding','0');
            $(this).closest('.portlet-column .rt-page__content').css('padding','0');
        }
    });

    $('.portlet-column').each(function () {
        if(!$(this).html().length) {
            $(this).css('padding','0');
        }
    });

    /* Page scroll */
    var headerHeight;
    var headerBottomHeight;
    var subheaderHeight;
    var paddingBody;
    /* Sidebar mobile behaviour */
    if (window.matchMedia("(min-width: 768px)").matches) {
        headerHeight = $('.rt-header').outerHeight();
        headerBottomHeight = $('.rt-header__bottom-area').outerHeight();
        subheaderHeight = 0;
        if ($('.rt-subheader--themes').length) {
            subheaderHeight = $('.rt-subheader--themes').outerHeight();
        }

        headerHeight = headerHeight + headerBottomHeight;
        paddingBody = headerHeight + subheaderHeight;


    } else if (window.matchMedia("(max-width: 767px)").matches) {
        headerHeight = $('.rt-header__bottom-area').outerHeight();
        paddingBody = headerHeight;
    }

    $(window).scroll(function () {
        if (window.matchMedia("(min-width: 768px)").matches) {
            if ($(window).scrollTop() >= headerHeight) {
                // alert(headerHeight);
                $('body').addClass('is-scrolled').css('padding-top', paddingBody + 'px');
            } else if ($(window).scrollTop() < headerHeight) {
                $('body').removeClass('is-scrolled').css('padding-top', '0');
            } 
        } else if (window.matchMedia("(max-width: 767px)").matches) {
            if ($(window).scrollTop() >= 56) {
                $('body').addClass('is-scrolled');
            } else if ($(window).scrollTop() < 56) {
                $('body').removeClass('is-scrolled');
            }
        }
    });

    /* Menu dropdown opening/close */
    $('.rt-main-navigation > .rt-main-navigation__item.has-submenu > a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var navItem = $(this).closest('.rt-main-navigation__item');

        var siblingItem = $(this).closest('.rt-main-navigation__item').siblings('li');
        var siblingIcon = siblingItem.find('i:not(.fa-chevron-right)');

        navItem.toggleClass('is-active');

        if (siblingIcon.hasClass('fa-chevron-up')) {
            siblingIcon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }

        siblingItem.removeClass('is-active');
        siblingItem.find('.rt-main-navigation__dropdown').removeClass('is-open');

        var dropdownMenu = $(this).next('.rt-main-navigation__dropdown');

        dropdownMenu.toggleClass('is-open');

        if (window.matchMedia("(min-width: 768px)").matches) {
            var menuIcon = $(this).find('i:not(.fa-chevron-right)');
            if (menuIcon.hasClass('fa-chevron-down')) {
                menuIcon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
            } else if (menuIcon.hasClass('fa-chevron-up')) {
                menuIcon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
        } else if (window.matchMedia("(max-width: 767px)").matches) {
            dropdownMenu.find('.rt-mobile-back').first().addClass('is-fixed');
        }
    });

    /* Tabs */
    $('.rt-main-navigation__tab').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var itemId = $(this).attr('id');

        $('.rt-main-navigation__tab-content').removeClass('is-active');
        $('.rt-main-navigation__tab-content[data-id="' + itemId + '"]').addClass('is-active');

        $(this).siblings('.rt-main-navigation__tab').removeClass('is-active');
        $(this).addClass('is-active');
    });

    /* Mobile menu back button */
    $('.rt-mobile-back').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).closest('.rt-main-navigation__dropdown').removeClass('is-open');
    });

    /* Mobile navbar toggle */
    $('.rt-navbar-toggle').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $('body').toggleClass('not-scrollable');

        var targetMenu = $('#navigationMain');
        targetMenu.toggleClass('is-open');

        $('.rt-main-navigation__dropdown').each(function () {
            if ($(this).hasClass('is-open')) {
                $(this).removeClass('is-open');
            }
        });

        $('.rt-mobile-back').each(function () {
            if ($(this).hasClass('is-fixed')) {
                $(this).removeClass('is-fixed');
            }
        });

        var menuIcon = $(this).find('i');
        toggleIcon(menuIcon);

        $('.rt-mobile-overlay').toggleClass('is-visible');
    });

    /* Mobile menu overlay */
    $('.rt-mobile-overlay').on('click', function () {
        $('.rt-main-navigation-container').removeClass('is-open');
        $(this).removeClass('is-visible');
        var menuIcon = $('.rt-navbar-toggle').find('i');
        toggleIcon(menuIcon);

    });

    /* Theme/subtheme submenu */
    $('.rt-subheader__item-has-submenu > a ').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idMenu = $(this).parent('.rt-subheader__item-has-submenu').attr('data-id');

        $('.rt-subheader__menu-submenu').each(function () {
            if ($(this).hasClass('is-open') && ($(this).attr('id') != idMenu)) {
                $(this).removeClass('is-open');
            }
        });

        $('.rt-subheader__menu').addClass('has-submenu-opened');


        $('.rt-subheader__item-has-submenu').each(function () {
            if ($(this).hasClass('is-active') && ($(this).attr('data-id') != idMenu)) {
                $(this).removeClass('is-active');
            }
        });

        $(this).parent('li').toggleClass('is-active');

        $('.rt-subheader__menu-submenu#' + idMenu).toggleClass('is-open');
    });

    $('.rt-subheader__menu-list li:not(.rt-subheader__item-has-submenu)> a').on('click', function (e) {
        //        e.preventDefault();
        //        e.stopPropagation();
        $('.rt-subheader__menu').removeClass('has-submenu-opened');
        $('.rt-subheader__menu-submenu').each(function () {
            if ($(this).hasClass('is-open')) {
                $(this).removeClass('is-open');
            }
        });

        $('.rt-subheader__item-has-submenu').each(function () {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
            }
        });
    });

    /* Subheader menu toggle */
    $('.rt-subheader-dropdown-toggle').on('click', function (e) {
        e.preventDefault();
        var subheaderMenu = $('.rt-subheader__menu');
        toggleIcon($(this).find('.rt-subheader-dropdown-toggle-text'));
        $('.rt-subheader__title--main').toggleClass('is-hidden');
        subheaderMenu.toggleClass('is-open');
        $('.rt-subheader').toggleClass('has-dropdown-open');
    });

    /* Close menu on outside click*/
    $('body').on('click', function (e) {
        if (!$(e.target).closest('.rt-main-navigation__dropdown').length && !$(e.target).is('.rt-main-navigation__dropdown')) {
            $('.rt-main-navigation__dropdown').removeClass('is-open');
            $('.rt-main-navigation__item').removeClass('is-active');

            if (window.matchMedia("(min-width: 768px)").matches) {
                $('.rt-main-navigation__item').find('i:not(.fa-chevron-right)').removeClass('fa-chevron-up').addClass('fa-chevron-down');
            }
        }

        if (!$(e.target).closest('.rt-main-navigation-panel').length && !$(e.target).is('.rt-main-navigation-panel')) {
            $('.rt-main-navigation-panel').removeClass('is-open');
            $('body').removeClass('not-scrollable');
        }
    });

    /* Search bar toggle button on page scroll */
    $('#search-toggle-scroll').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.rt-search-bar').toggleClass('is-open');
    });

    /* Search bar mobile toggle button */
    $('#search-toggle-mobile').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.rt-search-bar').toggleClass('is-open');
    });

    /* Search bar mobile toggle button */
    $('#search-toggle-tablet').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.rt-search-bar').toggleClass('is-open-tablet');
    });

    /* Sidebar mobile behaviour */
    if (window.matchMedia("(max-width: 767px)").matches) {
        $('.rt-sidebar__menu > .rt-sidebar__menu-item > a').on('click', function (e) {
            // e.preventDefault();
            // e.stopPropagation();

            $(this).closest('.rt-sidebar__menu-item').toggleClass('is-active');
        });
    }

    /* Expand/collapse toggle for section */
    $('.rt-section-expand').on('click', function (e) {
        e.preventDefault();
        var expandableSection = $(this).siblings('.rt-page__content-text-expandable-content');
        var ariaAttribute = $(this).attr('aria-expanded');
        expandableSection.toggleClass('is-shown');
        
        if(ariaAttribute == 'false') {
            $(this).attr('aria-expanded','true');
        } else {
            $(this).attr('aria-expanded','false');
        }
        
        var buttonText = $(this).html();

        if (buttonText == '<i aria-hidden="true" class="far fa-chevron-down"></i> Leggi tutto') {
            $(this).html('<i aria-hidden="true" class="far fa-chevron-up"></i> Meno');
        } else if (buttonText == '<i aria-hidden="true" class="far fa-chevron-up"></i> Meno') {
            $(this).html('<i aria-hidden="true" class="far fa-chevron-down"></i> Leggi tutto');
        }
    });

    /* Expand/collapse toggle for sidebar menu on mobile */
    $('.rt-mobile-menu-expand').on('click', function (e) {
        e.preventDefault();
        var sidebarMenu = $(this).siblings('.rt-sidebar__menu');
        var subheaderMenu = $(this).siblings('.rt-subheader__menu-list');

        if (sidebarMenu.length) {
            sidebarMenu.toggleClass('is-shown');
        }

        if (subheaderMenu.length) {
            subheaderMenu.toggleClass('is-shown');
        }

        var buttonText = $(this).html();
        if (buttonText.toLowerCase().indexOf("espandi") >= 0){
            $(this).html('Chiudi il menu <i aria-hidden="true" class="far fa-chevron-up"></i>');
        } else if (buttonText.toLowerCase().indexOf("chiudi") >= 0){
            $(this).html(' Espandi il menu <i aria-hidden="true" class="far fa-chevron-down"></i>');
        }
    });

    /* Homepage slider - inizializzazione */

    if ($('#menu-slider').length >= 1) {
        $('#menu-slider').flexslider({
            animation: "slide",
            controlNav: false,
            directionNav: false,
            keyboard: true,
            animationLoop: true,
            slideshow: false,
            itemWidth: 200,
            itemMargin: 5,
            asNavFor: '#main-slider'
        });

        $('#main-slider').flexslider({
            animation: "slide",
            controlNav: false,
            directionNav: false,
            keyboard: true,
            animationLoop: true,
            slideshow: true,
            sync: "#menu-slider"
        });
    }

    /* Social share */

    $('#sharebtn').on('click', function (e) {
        e.preventDefault();
        $('.taglib-social-bookmarks').toggleClass('is-visible');
        $('.rt-social-share-overlay').addClass('is-visible');
    });

    $('.rt-social-share-overlay').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.taglib-social-bookmarks').removeClass('is-visible');
        $(this).removeClass('is-visible');
    });

    /* Tooltip initialization */
    $('.rt-has-tooltip').tooltipster({
        theme: 'tooltipster-borderless',
        triggerClose: {
            click: true,
            tap: true
        }
    });

    //Open tooltip on page load
    $('.rt-has-tooltip').tooltipster('open');

    // Close tooltip after 3.5s
    setTimeout(function () {
        $('.rt-has-tooltip').tooltipster('close');
    }, 3500);

    /* Search filters sidebar mobile */
    var filtersSidebar = $('.sidebar-regione-toscana .portlet-barebone.portlet-nested-portlets');
    if (window.matchMedia("(max-width: 767px)").matches) {
        filtersSidebar.prepend('<a class="rt-search-filters-close" href="#">Chiudi <i aria-hidden="true" class="far fa-times"></i></a>');
    }

    $('.rt-search-filters-show').on('click', function (e) {
        e.preventDefault();
        filtersSidebar.addClass('is-open');
        $('body').addClass('not-scrollable');
    });

    $(document).on('click', '.rt-search-filters-close', function (e) {
        e.preventDefault();
        filtersSidebar.removeClass('is-open');
        $('body').removeClass('not-scrollable');
    });

    /* Video lightnox plugin initialization */
    // $('.rt-gallery__item-video a').magnificPopup({
    //     type: 'iframe',
    //     iframe: {
    //         markup: '<div class="mfp-iframe-scaler">' +
    //             '<div class="mfp-close"></div>' +
    //             '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
    //             '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

    //         patterns: {
    //             youtube: {
    //                 index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

    //                 id: 'v=', // String that splits URL in a two parts, second part should be %id%
    //                 // Or null - full URL will be returned
    //                 // Or a function that should return %id%, for example:
    //                 // id: function(url) { return 'parsed id'; }

    //                 src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
    //             }


    //             // you may add here more sources

    //         }


    //     }
    // });
});